import { utils, writeFile } from "xlsx";
import moment from "moment";

interface File {
  filename: string;
  blob: Blob;
}

export function downloadFile(file: File) {
  const a = document.createElement("a");
  const url = URL.createObjectURL(file.blob);
  a.href = url;
  a.download = file.filename;
  document.body.appendChild(a);
  a.click();

  setTimeout(() => {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
}

export const b64toBlob = (b64Data: string, contentType: string) => {
  contentType = contentType || "";
  var sliceSize = 512;
  b64Data = b64Data.replace(/^[^,]+,/, "");
  b64Data = b64Data.replace(/\s/g, "");
  var byteCharacters = window.atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const generateFilename = (
  page: string,
  portfolioName: string,
  startDate: string | undefined,
  endDate: string | undefined
) => {
  let filename = "";
  if (startDate && endDate) {
    const start = moment(new Date(startDate)).format("D.M.YYYY");
    const end = moment(new Date(endDate)).format("D.M.YYYY");

    filename = `${page}_${portfolioName}_${start}-${end}`;
  }
  return filename;
};

export const dataToExcelXlsx = <T>(data: T[], headers: string[][], fileName?: string) => {
  const objectMaxLength = [] as number[];

  data.forEach((d, idx) => {
    const values = Object.values(d);
    const keys = Object.keys(d);
    values.forEach((v, i) => {
      if (v === 0) {
        const obj: { [index: string]: any } = data[idx];
        obj[keys[i]] = "";
      }
      // tslint:disable-next-line: prefer-conditional-expression
      if (typeof v === "number") {
        objectMaxLength[i] = 10;
      } else {
        objectMaxLength[i] = objectMaxLength[i] >= v?.length ? objectMaxLength[i] : v?.length;
      }
    });
  });
  const wscols = objectMaxLength.map((l) => {
    return {
      // tslint:disable-next-line: strict-type-predicates
      width: l === undefined || l === 0 ? 15 : l + 1,
    };
  });

  const book = utils.book_new();

  utils.sheet_add_aoa(book, headers);
  const sheet = utils.sheet_add_json(book, data, {
    origin: "A2",
    skipHeader: true,
  });

  sheet["!cols"] = wscols;
  utils.book_append_sheet(book, sheet);

  writeFile(book, fileName ? `${fileName}.xlsx` : "output.xlsx");
};
